import { render } from "./JWait.vue?vue&type=template&id=69442662&scoped=true&ts=true"
import script from "./JWait.vue?vue&type=script&lang=ts"
export * from "./JWait.vue?vue&type=script&lang=ts"

import "./JWait.vue?vue&type=style&index=0&id=69442662&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69442662"]])

export default __exports__